<template>
    <section id="features" class="section features-area overflow-hidden mt-5 ptb_100">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-12 col-md-10 col-lg-6">
                        <!-- Section Heading -->
                        <div class="section-heading text-center">
                            <h2>Why Content Creators Love Turnkey Audience</h2>
                            <p class="mt-4">"I got into content creation to make content, not websites." -Just about every content creator.</p>
                            <p class="mt-4">Make your ultimate audience fanpage in (literally) 5-clicks.</p>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 col-md-6">
                        <div class="features-slider-wrapper overflow-hidden">
                            <!-- Work Slider -->
                            <ul class="features-slider owl-carousel">
                                <li class="slide-item">
                                    <img src="assets/img/screenshot_1.jpg" alt="">
                                </li>
                                <li class="slide-item">
                                    <img src="assets/img/screenshot_2.jpg" alt="">
                                </li>
                                <li class="slide-item">
                                    <img src="assets/img/screenshot_3.jpg" alt="">
                                </li>
                                <li class="slide-item">
                                    <img src="assets/img/screenshot_4.jpg" alt="">
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-12 col-md-6 pt-4 pt-md-0">
                        <ul class="features-item">
                            <li>
                                <!-- Image Box -->
                                <div class="image-box media icon-1 px-1 py-3 py-md-4 wow fadeInRight" data-aos-duration="2s" data-wow-delay="0.2s">
                                    <!-- Featured Image -->
                                    <div class="featured-img mr-3">
                                        <img class="avatar-sm" src="assets/img/featured_image_1.png" alt="">
                                    </div>
                                    <!-- Icon Text -->
                                    <div class="icon-text media-body align-self-center align-self-md-start">
                                        <h3 class="mb-2">Nothing Moves</h3>
                                        <p>Content on YouTube, Vimeo, Twitch and other platforms can stay right where it is, and all your existing monetization, sponsorships and analytics keeps working exactly the same.</p>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <!-- Image Box -->
                                <div class="image-box media icon-2 px-1 py-3 py-md-4 wow fadeInRight" data-aos-duration="2s" data-wow-delay="0.4s">
                                    <!-- Featured Image -->
                                    <div class="featured-img mr-3">
                                        <img class="avatar-sm" src="assets/img/featured_image_2.png" alt="">
                                    </div>
                                    <!-- Icon Text -->
                                    <div class="icon-text media-body align-self-center align-self-md-start">
                                        <h3 class="mb-2">Instant Loyalty</h3>
                                        <p>Our customizable, white-labeled loyalty system includes an assortment of awards, gamification, leaderboards and even cryptocurrency payouts for time spent watching your content.</p>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <!-- Image Box -->
                                <div class="image-box media icon-3 px-1 py-3 py-md-4 wow fadeInRight" data-aos-duration="2s" data-wow-delay="0.6s">
                                    <!-- Featured Image -->
                                    <div class="featured-img mr-3">
                                        <img class="avatar-sm" src="assets/img/featured_image_3.png" alt="">
                                    </div>
                                    <!-- Icon Text -->
                                    <div class="icon-text media-body align-self-center align-self-md-start">
                                        <h3 class="mb-2">Sponsorship NFTs</h3>
                                        <p>Our patent-pending Sponsorship NFTs let you stop wasting time finding sponsorships or conforming to release schedules. Get paid what you deserve, automatically using the blockchain.</p>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <!-- Image Box -->
                                <div class="image-box media icon-4 px-1 py-3 py-md-4 wow fadeInRight" data-aos-duration="2s" data-wow-delay="0.8s">
                                    <!-- Featured Image -->
                                    <div class="featured-img mr-3">
                                        <img class="avatar-sm" src="assets/img/featured_image_4.png" alt="">
                                    </div>
                                    <!-- Icon Text -->
                                    <div class="icon-text media-body align-self-center align-self-md-start">
                                        <h3 class="mb-2">Easy to Customize</h3>
                                        <p>Most Content Creators publish their Audience site within the first 15 minutes. The site creator is <u>specifically</u> for content creators. Every setting and option is relevant to you.</p>
                                    </div>
                                </div>
                                <a href="#" class="btn btn-bordered mt-4">Learn More</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </section>
</template>

<script>
export default {
    
}
</script>

<style>

</style>